/**************************************************
 * Nombre:       Profesional_Registro_Educacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {COLORTEXTO} from "../../../Constantes";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import Tarjeta_Educacion from "../../Tarjetas/Tarjeta_Educacion";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";


const Profesional_Registro_Educacion = () => {
    const {props, obtenerEntidad, limpiarEntidad} = useFormulario({valoresDefecto: {}})
    const {Cargador, nuevoAviso, Avisos, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: limpiarEntidad
    })

    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        iniciarCarga('Creando solicitud')

        let dox = await guardarDoc('solicitudes', entidad)
        if (dox.res) {
            terminar({aviso: 'No hay citas disponibles con este profesional, te avisaremos cuando tenga agenda libre'})
        } else {
            terminar({aviso: 'Algo salio mal, intentalo nuevamente', variante: 'error'})
        }

    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Cargador/>

            <Avisos/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={8}
                    >

                        {/*}   <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 4}}
                            sx={{
                                backgroundColor: '#fff',
                                borderRadius: 6,
                                px: 4,
                                py: 6,
                                color: COLORTEXTO
                            }}
                            spacing={0}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                <Typography sx={{fontSize: 20, fontWeight: 800}}>Reserva tu Cita</Typography>
                            </Grid>

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{mt: 3}}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Formulario_Reserva props={props}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 3}}>
                                    <Boton click={subirDatos} texto={'Ingresar'}/>
                                </Grid>

                            </Grid>


                        </Grid> */}

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 8}}
                            spacing={0}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontSize: 42, fontWeight: 800, color: COLORTEXTO}}>
                                    Educacion y Experiencia
                                </Typography>
                            </Grid>

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{mt: 2}}
                                spacing={0}
                            >


                                {educaciones.map(item => (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Tarjeta_Educacion item={item}/>
                                    </Grid>
                                ))}

                            </Grid>

                        </Grid>

                        {/*}   <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontSize: 40, fontWeight: 800}}>Horarios Disponibles -
                                    Semana</Typography>
                            </Grid>

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{mt: 2}}
                            >

                                {horarios.map(item => (
                                    <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>
                                        <Button
                                            sx={{borderRadius: 2, px: 2}}
                                            fullWidth
                                            disabled={item.activo}
                                        >
                                            <Grid
                                                container
                                                justifyContent={'flex-start'}
                                                alignItems={'flex-start'}
                                                size={{xs: 12, sm: 12, md: 12}}>

                                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                      sx={{justifyContent: 'center'}}>
                                                    <Typography
                                                        sx={{fontSize: 18, fontWeight: 600}}>{item.nombre}</Typography>
                                                </Grid>

                                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                      sx={{justifyContent: 'center'}}>
                                                    <Typography>{item.hora}</Typography>
                                                </Grid>

                                            </Grid>

                                        </Button>
                                    </Grid>
                                ))}

                            </Grid>

                        </Grid> */}

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Profesional_Registro_Educacion

const educaciones = [

    {
        nombre: 'Educacion',
        descripcion: 'doctor en medicina y cirugía., máster en psico-neuro-inmuno-endocrinología, especialista en psiquiatría, psicología clínica y neurocirugía',
    },
    {
        nombre: 'Certificaciones',
        descripcion: 'International Distinguished Fellow de la American Psychiatry Association. Autor de libros y publicaciones nacionales e internacionales',
    },
    {
        nombre: 'Campo de Experiencia',
        descripcion: ' Miembro fundador del Centro Viktor Frankl para la Difusión de la Logoterapia (Buenos Aires',
    },
    {
        nombre: 'Años de Experiencia',
        descripcion: '24',
    },
]

const horarios = [
    {
        nombre: 'Lunes',
        hora: '8am - 9am',
        activo: true

    },
    {
        nombre: 'Martes',
        hora: '9am - 10am',
        activo: true
    },
    {
        nombre: 'Miercoles',
        hora: '8am - 9am',
        activo: true
    },
    {
        nombre: 'Jueves',
        hora: '8am - 9am',
        activo: true
    },
    {
        nombre: 'Viernes',
        hora: '8am - 9am',
        activo: true
    },

    {
        nombre: 'Sabado',
        hora: '8am - 9am',
        activo: true
    },

]